import { render, staticRenderFns } from "./TableCodigosStorage.vue?vue&type=template&id=67ad91f7"
import script from "./TableCodigosStorage.vue?vue&type=script&lang=js"
export * from "./TableCodigosStorage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports